import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "../ui/button";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ce7c35c8-38b3-46c7-87cc-f9c9273d3bf9/artifacts/tdjkcjsv_Comision%20Empresarial.png";

const NAV_LINKS = [
  { href: "#quienes-somos", label: "Quiénes Somos" },
  { href: "#mision-vision", label: "Misión & Visión" },
  { href: "#valores", label: "Valores" },
  { href: "#servicios", label: "Servicios" },
  { href: "#contacto", label: "Contacto" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200 shadow-[0_1px_0_rgba(2,33,64,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="container-page flex items-center justify-between h-[72px]">
        <a
          href="#inicio"
          onClick={(e) => handleLinkClick(e, "#inicio")}
          className="flex items-center"
          data-testid="navbar-logo"
        >
          <img
            src={LOGO_URL}
            alt="Comisión Empresarial"
            className="h-14 sm:h-16 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleLinkClick(e, l.href)}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="px-4 py-2 text-sm font-medium text-[#022140]/80 hover:text-[#055794] transition-colors rounded-md hover:bg-[#72B3E4]/10"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Button
            data-testid="navbar-cta"
            onClick={(e) => handleLinkClick(e, "#contacto")}
            className="bg-[#022140] hover:bg-[#055794] text-white rounded-full px-5 h-10 font-medium transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#055794]/20"
          >
            Hablemos
          </Button>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          className="lg:hidden p-2 text-[#022140]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden bg-white border-t border-slate-200 px-6 py-6 flex flex-col gap-1"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleLinkClick(e, l.href)}
              className="py-3 text-[#022140] font-medium border-b border-slate-100"
              data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="mobile-navbar-cta"
            onClick={(e) => handleLinkClick(e, "#contacto")}
            className="mt-4 bg-[#022140] hover:bg-[#055794] text-white rounded-full w-full"
          >
            Hablemos
          </Button>
        </div>
      )}
    </header>
  );
};
